import type { EventProps } from './types';

export const clickTracking = ({
  emitter,
  trackClick,
}: Omit<EventProps, 'hotjarTracking'>): void => {
  //#region top bar top level
  emitter.on('clickedLogo', (event) => {
    trackClick('Main logo', event.position);
  });

  emitter.on('clickedInviteMembers', (event) => {
    trackClick('Invite team members', event.position);
  });

  emitter.on('clickedGSGItem', (event) => {
    trackClick('Getting started guide item', event.position);
  });
  //#endregion

  //#region site selector
  emitter.on('clickedSiteSelector', (event) => {
    trackClick('Site selector', event.position);
  });

  emitter.on('focusedSiteSelectorSearch', (event) => {
    trackClick('Focused site search', event.position);
  });

  emitter.on('searchedSites', (event) => {
    trackClick('Searched sites', event.position);
  });

  emitter.on('selectedSite', (event) => {
    trackClick('Selected a site', event.position);
  });

  emitter.on('clickedAddNewSite', (event) => {
    trackClick('Add new site', event.position);
  });
  //#endregion

  //#region help menu
  emitter.on('clickedHelpMenu', (event) => {
    trackClick('Help menu dropdown', event.position);
  });

  emitter.on('clickedGetHelp', (event) => {
    trackClick('Get Help', event.position);
  });

  emitter.on('clickedBrowseGuides', (event) => {
    trackClick('Browse guides', event.position);
  });

  emitter.on('clickedExploreCourses', (event) => {
    trackClick('Explore courses', event.position);
  });

  emitter.on('clickedProductUpdates', (event) => {
    trackClick('Product updates', event.position);
  });

  emitter.on('clickedSystemStatus', (event) => {
    trackClick('System status', event.position);
  });
  //#endregion

  //#region account menu
  emitter.on('clickedAccountMenu', (event) => {
    trackClick('Account menu', event.position);
  });

  emitter.on('clickedProfileSummary', (event) => {
    trackClick('Profile summary', event.position);
  });

  emitter.on('clickedViewProfile', (event) => {
    trackClick('View profile', event.position);
  });

  emitter.on('clickedAccountSettings', (event) => {
    trackClick('Account settings', event.position);
  });

  emitter.on('clickedBilling', (event) => {
    trackClick('Billing', event.position);
  });

  emitter.on('clickedUpgradeYourPlan', (event) => {
    trackClick('Upgrade your plan', event.position);
  });

  emitter.on('clickedLogout', (event) => {
    trackClick('Logout', event.position);
  });
  //#endregion

  //#region nav toolbar
  emitter.on('clickedSidebarExpand', (event) => {
    trackClick('Expand sidebar', event.position);
  });
  emitter.on('clickedSidebarCollapse', (event) => {
    trackClick('Collapse sidebar', event.position);
  });
  emitter.on('clickedOverview', (event) => {
    trackClick('Space overview', event.position);
  });
  emitter.on('clickedDashboardQuantz', (event) => {
    trackClick('Quantitative dashboard', event.position);
  });
  emitter.on('clickedHighlights', (event) => {
    trackClick('Highlights', event.position);
  });
  emitter.on('clickedTrends', (event) => {
    trackClick('Trends', event.position);
  });
  emitter.on('clickedRecordings', (event) => {
    trackClick('Recordings', event.position);
  });
  emitter.on('clickedHeatmaps', (event) => {
    trackClick('Heatmaps', event.position);
  });
  emitter.on('clickedFeedback', (event) => {
    trackClick('Feedback', event.position);
  });
  emitter.on('clickedSurveys', (event) => {
    trackClick('Surveys', event.position);
  });
  emitter.on('clickedOrgsAndSites', (event) => {
    trackClick('Organizations and Sites', event.position);
  });
  emitter.on('clickedTeam', (event) => {
    trackClick('Team', event.position);
  });
  emitter.on('clickedUserAttributes', (event) => {
    trackClick('User attributes', event.position);
  });
  emitter.on('clickedIntegrations', (event) => {
    trackClick('Integrations', event.position);
  });
  emitter.on('clickedUserLookup', (event) => {
    trackClick('User lookup', event.position);
  });
  emitter.on('clickedSSO', (event) => {
    trackClick('SSO', event.position);
  });
  emitter.on('clickedPlansBilling', (event) => {
    trackClick('Plans & Billing', event.position);
  });
  emitter.on('clickedSubscriptions', (event) => {
    trackClick('Subscriptions', event.position);
  });
  emitter.on('clickedInvoices', (event) => {
    trackClick('Invoices', event.position);
  });
  emitter.on('clickedPreferences', (event) => {
    trackClick('Preferences', event.position);
  });
  emitter.on('clickedMyDetails', (event) => {
    trackClick('My Details', event.position);
  });
  emitter.on('clickedNotifications', (event) => {
    trackClick('Notifications', event.position);
  });
  emitter.on('clickedReferAndEarn', (event) => {
    trackClick('Refer & Earn', event.position);
  });
  //#endredion
};
